
import React, { useState, useRef, useEffect } from 'react';

const DeskRejected = ({renderChevronContainer, postersPath, initialData, isParent}) => {

  const [expanded, setExpanded] = useState(false);
  const [tableData, setTableData] = useState(false);
  const firstUpdate = useRef(true);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    fetchData();
  }, [expanded])

  const setColumns = () => {
    if(isParent) {
      return [
        {width: '160px'},
        null,
        {width: '160px'},
        {width: '160px'},
        {width: '160px'},
        null
      ]
    } else {
      return [
        {width: '160px'},
        null,
        {width: '160px'},
        {width: '160px'},
        null
      ]
    }
  }

  const mapColumns = (dt, row) => {
    if(isParent) {
      return (
        dt.fnAddData( [
          row.blocked_on,
          row.sort_column,
          row.channel_name,
          row.blocked_by,
          row.submitting_author,
          row.title
      ], false)
      )
    } else {
      return (
        dt.fnAddData( [
          row.blocked_on,
          row.sort_column,
          row.blocked_by,
          row.submitting_author,
          row.title
      ], false)
      )
    }
  }

  const populateTable = (fetchedTableData) => {
    var dt = $("#desk-rejected-table").DataTable({
      columns: setColumns(),
      columnDefs: [
        {targets: [0], orderData: [1]},
        {targets: [1], visible: false}
      ],
      dom: '<"row">tr<"row"<"large-8 columns pagination-details" <"pull-left"p><"pull-left showing-info"i>><"large-4 columns table-length-container"<"text-right"l>>>',
      "bAutoWidth": false,
      "fnDrawCallback": function(oSettings) {
        if (oSettings.fnRecordsDisplay() == 0) {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').hide();
          $(oSettings.nTableWrapper).find('.dataTables_length').hide();
          $(oSettings.nTableWrapper).find('.dataTables_info').hide();
        } else if (oSettings._iDisplayLength > oSettings.fnRecordsDisplay()) {
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        } else {
          $(oSettings.nTableWrapper).find('.dataTables_paginate').show();
          $(oSettings.nTableWrapper).find('.dataTables_length').show();
          $(oSettings.nTableWrapper).find('.dataTables_info').show();
        }
      },
      searching: false,
    })
    
    dt.api().clear();
    for (var i = 0; i < fetchedTableData.posters.length; i++) {
      let row = fetchedTableData.posters[i];
      mapColumns(dt, row)
    }
    dt.fnSort([[1, 'desc']])
    dt.fnDraw()
  }

  const fetchData = () => {
    if(tableData) {
      populateTable(tableData)
      return;
    }

    $.ajax({
      type: 'GET',
      url: postersPath,
      data: {state: 'DeskRejected'},
      success: function(data) {
        setTableData(data)
        populateTable(data)
      }
    });
  }

  const renderHeaderRow = () => {
    return (
      <div className="row article-state-row">
        <div className="small-1 columns bubble-container has-tip tip-top" data-tooltip="" title={initialData.tooltip}>
          <img src={`https://public.cureus.com/channel-icons/grey-bubble.png`} />
          <span className="bubble-text" >{initialData.total}</span>
        </div>
        <div className="small-9 columns article-state-label">
          <h4>{initialData.label}</h4>  
          <span>{initialData.blurb}</span>
        </div>
        <div className="small-1 columns chevron-container">
          {renderChevronContainer(expanded, setExpanded)}
        </div>
      </div>
    )
  }

  const renderChannel = () => {
    if(isParent) {
      return <th>Channel</th>
    }
  }

  return (
    <React.Fragment>
      <div className="article-state-row-container">
        {renderHeaderRow()}
        {expanded && 
          <div className="channel-articles-datatable-container">
            <table id="desk-rejected-table">
              <thead>
                <tr>
                  <th>Block date</th>
                  <th></th>
                  {renderChannel()}
                  <th>Channel Curator/Admin</th>
                  <th>Submitting author</th>
                  <th>Title</th>
                </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        }        
      </div>

    </React.Fragment>
  )
}

export default DeskRejected;